module.exports = __webpack_public_path__ + "static/media/ConsultSpecialists.1380aed1.png";